import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  portrait: {},
  landscape: {},
  isFullscreen: {
    // maxHeight: '100vh'
  },
  page: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    '&$portrait': {
      '@media (max-width: 1023px)': {
        '& $actionsBoxVisible': {
          width: 300
        }
      },
      '@media (max-width: 767px)': {
        '& $container': {
          maxHeight: 'initial',
          display: 'flex',
          flexDirection: 'column'
        },
        '& $actionsBox': {
          display: 'none'
        },
        '& $actionsBoxMobile': {
          display: 'block',
          width: '100%',
          height: 'calc(100vw + 395px)'
        }
      }
    },
    '&$landscape': {
      '@media (max-width: 1023px)': {
        '& $actionsBoxVisible': {
          display: 'none'
        }
      }
    }
  },
  container: {
    display: 'flex',
    width: '100%',
    maxHeight: '100vh'
  },
  videoBox: {
    flexGrow: 1,
    position: 'relative',
    transition: theme.transitions.create(['width'], {
      easing: theme.transitions.easing.easeOut,
      duration: '500ms',
      delay: '300ms'
    })
  },
  actionsBox: {
    overflow: 'hidden',
    width: 0,
    flexShrink: 0,
    backgroundColor: 'white',
    transition: theme.transitions.create(['width'], {
      easing: theme.transitions.easing.easeOut,
      duration: '500ms',
      delay: '300ms'
    })
  },
  actionsBoxMobile: {
    display: 'none'
  },
  actionsBoxVisible: {
    width: 360
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/pages/Live/styles.js